import * as auto from './exportI18n-km'

export default {
  login: require('./login'),
  store: require('./store'),
  common: require('./common'),
  product: require('./product'),
  order: require('./order'),
  ...require('./avue-km'),
  ...auto.Inject(auto)
}
